(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gnome-card-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gn-card-options')) {
 customElements.define('gn-card-options', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   const template = this.querySelector('template');
   if (!template) return;
   this.dataset.ready = 'true';
   const variants = [...template.content.querySelectorAll('[data-variant]')].map(el => ({...el.dataset, options:JSON.parse(el.dataset.options)}));
   if (!variants.length) return;
   const names = JSON.parse(template.content.querySelector('[data-variants]').dataset.names);
   const card = this.closest('.gn-card');
   const controls = document.createElement('div');
   controls.className = 'gn-preview-options';
   const featuredVariants = variants.filter(v => v.imageId === this.dataset.featuredImageId);
   let current = featuredVariants.find(v => v.available === 'true') || featuredVariants[0] || variants.find(v => v.available === 'true') || variants[0];
   const selects = names.map((name, index) => {
    const label = document.createElement('label');
    label.append(document.createTextNode(name));
    const select = document.createElement('select');
    select.setAttribute('aria-label', card.querySelector('h3').textContent.trim() + ': ' + name);
    for (const value of new Set(variants.map(v => v.options[index]))) select.add(new Option(value, value));
    select.value = current.options[index];
    label.append(select); controls.append(label);
    select.addEventListener('change', () => {
     const values = selects.map(s => s.value);
     current = variants.find(v => v.options.every((o,i) => o === values[i])) || variants.find(v => v.options[index] === select.value && v.available === 'true') || variants.find(v => v.options[index] === select.value);
     selects.forEach((s,i) => { s.value = current.options[i]; });
     render();
    });
    return select;
   });
   const status = document.createElement('p'); status.className = 'gn-preview-status'; status.setAttribute('role','status');
   this.append(controls,status);
   const render = (updateImage = true) => {
    card.querySelectorAll('.gn-card-image,h3 a,.gn-card-link').forEach(a => { a.href = current.url; });
    const img = card.querySelector('.gn-card-image img');
    if (updateImage && img && current.image) { img.removeAttribute('srcset'); img.src = current.image; img.alt = card.querySelector('h3').textContent.trim() + ' - ' + current.options.join(' / '); }
    const price = document.createElement('div'); price.className = 'gn-preview-price';
    if (current.compare) { const old = document.createElement('s'); old.textContent = current.compare; old.setAttribute('aria-label',this.dataset.compareLabel + ': ' + current.compare); price.append(old); }
    const amount = document.createElement('strong'); amount.textContent = current.price; amount.setAttribute('aria-label',this.dataset.priceLabel + ': ' + current.price); price.append(amount);
    card.querySelector('.gn-card-price').replaceChildren(price);
    const form = card.querySelector('.gn-quick-form');
    if (form) {
     form.querySelector('input[name="id"]').value = current.id;
     form.dataset.productId = current.productId;
     form.dataset.productUrl = current.url.split('?')[0];
     form.querySelector('[type="submit"]').disabled = current.available !== 'true';
     form.querySelector('.gn-add-label').textContent = current.available === 'true' ? form.dataset.add : this.dataset.soldOut;
     form.querySelector('.gn-quick-feedback').textContent = '';
    }
    status.textContent = current.available === 'true' ? '' : this.dataset.soldOut;
   };
   render(false);
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gnome-cardigan-colors"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
 const link = event.target.closest('[data-cardigan-color]');
 if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
 const group = link.closest('[data-cardigan-colors]');
 const current = JSON.parse(group.dataset.currentVariants);
 const selectedId = new URL(location.href).searchParams.get('variant');
 const selectedSize = current.find(v => String(v.id) === selectedId)?.title || group.dataset.selectedSize;
 const target = JSON.parse(link.dataset.variants).find(v => v.title === selectedSize);
 if (target) {
  const url = new URL(link.href);
  url.searchParams.set('variant', target.id);
  link.href = url.href;
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gnome-personalization"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.gnomeNameCounterReady) return;
  window.gnomeNameCounterReady = true;
  const selector = '[data-gn-name-counter]';
  const update = (input, attempted = false) => {
    const box = document.getElementById(input.dataset.gnNameCounter);
    if (!box) return;
    const max = input.maxLength > 0 ? input.maxLength : 30;
    const length = input.value.length;
    const atLimit = length >= max;
    box.querySelector('[data-gn-count]').textContent = `${length}/${max}`;
    const message = box.querySelector('[data-gn-limit]');
    const text = atLimit || attempted ? box.dataset.limitText : '';
    if (message.textContent !== text) message.textContent = text;
    box.classList.toggle('is-limit', atLimit);
    if (attempted) {
      box.classList.remove('is-bump');
      void box.offsetWidth;
      box.classList.add('is-bump');
    }
  };
  document.addEventListener('beforeinput', (event) => {
    const input = event.target;
    if (!input.matches?.(selector) || !event.inputType?.startsWith('insert')) return;
    const max = input.maxLength > 0 ? input.maxLength : 30;
    const selected = (input.selectionEnd ?? 0) - (input.selectionStart ?? 0);
    const adding = (event.data ?? event.dataTransfer?.getData('text/plain') ?? '').length || 1;
    if (input.value.length - selected + adding > max) requestAnimationFrame(() => update(input, true));
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches?.(selector)) update(event.target);
  });
  const refreshAll = () => document.querySelectorAll(selector).forEach((input) => update(input));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAll);
  else refreshAll();
  window.addEventListener('pageshow', refreshAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gnome-quick-add"] && !Shopify.designMode) return;
  try {
    (async () => {
 if (window.gnomeQuickAddReady) return;
 window.gnomeQuickAddReady = true;
 const {StandardEvents} = await import('@shopify/events');
 document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const form = event.target.closest?.('.gn-quick-form');
  if (!form || !event.promise) return;
  const card = form.closest('.gn-card');
  const button = form.querySelector('[type="submit"]');
  const label = button.querySelector('.gn-add-label');
  const feedback = form.querySelector('.gn-quick-feedback');
  const selects = card.querySelectorAll('.gn-preview-options select');
  form.setAttribute('aria-busy','true'); button.disabled = true;
  selects.forEach(select => { select.disabled = true; });
  label.textContent = form.dataset.adding; feedback.textContent = '';
  event.promise.then(({detail}) => {
   if (!detail?.didError) feedback.textContent = form.dataset.added;
  }).catch(() => { feedback.textContent = form.dataset.failed; }).finally(() => {
   form.removeAttribute('aria-busy'); button.disabled = false;
   selects.forEach(select => { select.disabled = false; });
   label.textContent = form.dataset.add;
  });
 });
})();
  } catch(e) { console.error(e); }
})();

})();
